import * as React  from 'react';
import './styles.scss';


export default class Collapsible extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
        };
        this.changeCollapsibleState = this.changeCollapsibleState.bind(this);
    }

    // componentDidMount(){
    //     //this.setState({open: this.props.open})
    // }
    // componentWillReceiveProps(nextProps){
    //     // if( nextProps.open !== this.props.open){
    //         //this.setState({open: nextProps.open});
    //     // }
    // }

    changeCollapsibleState(value){
        this.setState({open: value});
        this.props.updateCollapsibleState(value)
    }

    render() {
        return (
            <React.Fragment>
                {this.props.header && !this.state.open &&
                    this.props.header
                }
                {!this.state.open &&
                    <span onClick={ () => { this.changeCollapsibleState(!this.state.open) } }> <this.props.openButton /> </span>
                }
                {this.state.open &&
                    this.props.children
                }
                {this.state.open &&
                    <span onClick={() => {this.changeCollapsibleState(!this.state.open)  } }> <this.props.closeButton /> </span>
                }
            </React.Fragment>

        );
    }
}